import React, { Component } from 'react'
import { connect } from 'react-redux'
import { mapValidationFieldsToClassName } from '../../forms/inputValidations'


class SSN4 extends Component {
    onChange = () => {
        const value = this.refs.ssn4.value
        this.props.onChange({ssn4: value})
    }


    render() {
        return (
            <div className="ssn-item ssn-selector">
                <label htmlFor="ssn-last-four">Four Digit SSN: </label>
                <input type="text"
                       maxLength="128"
                       id="ssn-last-four"
                       size="4"
                       ref="ssn4"
                       onBlur={this.onChange}
                       className={this.props.className} />
            </div>
        )
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.value) {
            this.refs.ssn4.value = ''
        }
    }
}

function mapStateToProps(state) {
    return {
        className: mapValidationFieldsToClassName(state, 'ssn4', 'input-search').className,
        value: state.getIn(['pacerSearchResults', 'filters', 'ssn4'])
    }
}

export default connect(mapStateToProps)(SSN4)



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/ssnSelectors/SSN4.js
 **/